
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.29 8a7.294 7.294 0 00-4.374-6.683.682.682 0 10-.546 1.25 5.93 5.93 0 011.238 10.135l.463-2.328a.682.682 0 10-1.337-.267l-.76 3.819a.682.682 0 00.536.802l3.818.76a.682.682 0 00.266-1.337l-2.09-.417A7.296 7.296 0 0015.29 8zM4.465 6.428a.682.682 0 00.802-.536l.76-3.818a.682.682 0 00-.536-.801L1.673.513a.682.682 0 00-.266 1.338l2.092.416A7.307 7.307 0 00.711 8a7.293 7.293 0 004.374 6.683.68.68 0 00.897-.351.682.682 0 00-.351-.898A5.93 5.93 0 012.075 8c0-1.863.879-3.593 2.318-4.7L3.93 5.626a.682.682 0 00.535.801z","fill":"#E2E8F0"}})])
          )
        }
      }
    